// /wp-json/custom/menu

import React from 'react';
import Loadable from 'react-loadable';
import Loading from '../Loader';
import Menu from './Menu';
import getMenu from './getMenu';

export default Loadable({
	loader: getMenu,
	loading: Loading,
	render(loaded, props) {
		return <Menu menuContent={loaded}>{props.children}</Menu>;
	}
});



// WEBPACK FOOTER //
// ./src/modules/Menu/index.js